import React, { useState, useEffect } from 'react';

const Stat = ({ title, value, description }) => {
  const [displayedValue, setDisplayedValue] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = parseInt(value.replace(/[^0-9]/g, ''), 10); // Extract numeric value
    const duration = 5000; // Duration of the animation (in ms)
    const increment = end / (duration / 100); // Increment step (every 100ms)
    
    const animate = () => {
      if (start < end) {
        start += increment;
        setDisplayedValue(Math.min(Math.floor(start), end)); // Update the value
        requestAnimationFrame(animate); // Call next frame
      } else {
        setDisplayedValue(end); // Ensure it ends exactly at the target value
      }
    };
    
    animate();
  }, [value]);

  return (
    <div className="stat">
      <div className="stat-title">{title}</div>
      <div className="stat-value">{displayedValue}+</div>
      <div className="stat-desc">{description}</div>
    </div>
  );
};

export default Stat;
